var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/has-binary2/node_modules/isarray/index.js
// module id = 39
// module chunks = 0